import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  ViewerCustomizationInterface,
  instanceOfViewerGroupAttribute,
  instanceOfViewerGroupCustomizations,
  ViewerGroupInterface,
  ViewerOptionInterface,
  instanceOfViewerGroupStep,
  ViewerItemInterface,
  CustomizationsState,
  ViewerGroupInputItemsInterface,
  ViewerOptionInterfaceInput,
} from '../../core';

import MenuChoiceSteps from '../MenuChoiceSteps';
import MenuChoiceAttributes from '../MenuChoiceAttributes';

import styles from './MenuChoice.module.scss';
import MenuChoiceCustomizations from '../MenuChoiceCustomizations';

export interface MenuChoiceProps {
  group: ViewerGroupInterface;
  selectedStepId: string | null;
  selectedAttributeId: string | null;
  customizationsState: CustomizationsState;
  bulkData: ViewerGroupInputItemsInterface | null;
  setBulkDataOptionValue: (option: ViewerOptionInterfaceInput, value: string) => void;
  showOptionPreview: (option: ViewerOptionInterface) => void;
  showCustomizationInfo: (info: ViewerCustomizationInterface) => void;
  optionSelect: (option: ViewerItemInterface) => void;
  setCustomizationsState: (customizationsState: CustomizationsState) => void;
  onAddImageItem: (guid: number, areaId: number) => Promise<void>;
  onItemRemove: (guid: string) => Promise<void>;
}

const MenuChoice: React.FC<MenuChoiceProps> = (props) => {
  const [t] = useTranslation();
  const description = t(`${props.group?.id}_DESCRIPTION`);
  return (
    <div className={styles.ff_menu_choice} data-testid='ff-menu-choice'>
      {description !== `${props.group?.id}_DESCRIPTION` ? (
        <div className={styles.ff_menu_choice_title}>
          <div>{description}</div>
        </div>
      ) : null}

      {(instanceOfViewerGroupAttribute(props.group) && !!props.group.attributes?.length && (
        <MenuChoiceAttributes
          attributes={props.group.attributes}
          showOptionPreview={props.showOptionPreview}
          optionSelect={props.optionSelect}
          bulkDataAttributes={props.bulkData?.attributes}
          setBulkDataOptionValue={props.setBulkDataOptionValue}
        />
      )) ||
        (instanceOfViewerGroupStep(props.group) && !!props.group.steps?.length && (
          <MenuChoiceSteps
            steps={props.group.steps}
            showOptionPreview={props.showOptionPreview}
            optionSelect={props.optionSelect}
            bulkDataAttributes={props.bulkData?.attributes}
            setBulkDataOptionValue={props.setBulkDataOptionValue}
          />
        )) ||
        (instanceOfViewerGroupCustomizations(props.group) && !!props.group.productAreas.length && (
          <MenuChoiceCustomizations
            customizations={props.group}
            showCustomizationInfo={props.showCustomizationInfo}
            optionSelect={props.optionSelect}
            customizationsState={props.customizationsState}
            setCustomizationsState={props.setCustomizationsState}
            onItemRemove={props.onItemRemove}
            onAddImageItem={props.onAddImageItem}
          />
        ))}
    </div>
  );
};

export default MenuChoice;
